var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHavenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "H1 Brand Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0ZM11.9612 19.1728L11.2802 18.0642C10.5048 16.8034 10.5048 15.1966 11.2802 13.9358L11.9612 12.8272C13.2491 10.7309 11.7809 8 9.36536 8C8.6102 8 8 8.62782 8 9.40093V22.5991C8 23.3739 8.61188 24 9.36536 24C11.7809 24 13.2491 21.2691 11.9612 19.1728ZM13.716 15.9991C13.716 17.3966 14.8201 18.5277 16.1804 18.5277C17.5424 18.5277 18.6448 17.3966 18.6448 15.9991C18.6448 14.6017 17.5424 13.4705 16.1804 13.4705C14.8184 13.4705 13.716 14.6017 13.716 15.9991ZM22.6346 24C23.3898 24 24 23.3722 24 22.5991V9.40093C24 8.62609 23.3881 8 22.6346 8C20.2191 8 18.7509 10.7309 20.0388 12.8272L20.7198 13.9358C21.4952 15.1966 21.4952 16.8034 20.7198 18.0642L20.0388 19.1728C18.7509 21.2691 20.2191 24 22.6346 24Z",
    fill: "#1F63FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHavenLogo);
export default __webpack_public_path__ + "static/media/haven-logo.f2bd73f15e1d28a202c78ccc4811f163.svg";
export { ForwardRef as ReactComponent };